import { render, staticRenderFns } from "./pMetro.vue?vue&type=template&id=2fcb057e"
import script from "./pMetro.vue?vue&type=script&lang=js"
export * from "./pMetro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports